import { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { useLocation, useParams } from 'react-router-dom';
import { shallow } from 'zustand/shallow';

import { useShareData } from '../../context';
import { PostTemplate } from '../../components/Templates';
import { NOT_APPLICABLE_STRING } from '../../constants/general';
import { PostContentType } from '../../models/PostStore/Post';
import { ProfileMapType } from '../../models/UserStore';
import { usePostStore } from '../../stores/PostStore';
import { useSessionStore } from '../../stores/SessionStore';
import { useSpaceStore } from '../../stores/SpaceStore';
import { useUserStore } from '../../stores/UserStore';

const { fetchPost } = usePostStore.getState();

export const PostScreen = () => {
  // const navigate = useNavigate();
  const { id } = useParams();

  const { setSharedData } = useShareData();

  const location = useLocation();
  useEffect(() => {
    setSharedData({
      pathName: location.pathname,
    });
  }, [location.pathname, setSharedData]);

  const [status, setStatus] = useState<'ok' | 'loading' | 'error'>('ok');

  useEffect(() => {
    const loadPostAndMembership = async () => {
      try {
        setStatus('loading');
        await fetchPost(id ?? NOT_APPLICABLE_STRING);
        setStatus('ok');
      } catch (error) {
        console.error(error);
        setStatus('error');
      }
    };

    loadPostAndMembership().catch(console.error);
  }, [id]);

  const post = usePostStore((store) =>
    store.getPost(id ?? NOT_APPLICABLE_STRING),
  );

  const creatorUserId = post?.createdBy ?? NOT_APPLICABLE_STRING;
  const creatorUserProfile = useUserStore.getState().getProfile(creatorUserId);

  const spaceId = post?.channel.id ?? NOT_APPLICABLE_STRING;
  const classroom = useSpaceStore((store) => {
    return store.getSpace(spaceId);
  }, shallow);

  // album
  const album = useSpaceStore((store) => {
    return store.getAlbum(
      post?.content.type == PostContentType.Album
        ? post.content.gameSetId
        : NOT_APPLICABLE_STRING,
    );
  }, shallow);
  const albumClassroom = useSpaceStore((store) => {
    return store.getSpace(album?.classroomId ?? NOT_APPLICABLE_STRING);
  }, shallow);

  // membership
  const currentUserId =
    useSessionStore.getState().activeUserId ?? NOT_APPLICABLE_STRING;
  const membership = useSpaceStore(
    (state) => state.getMembership(spaceId, currentUserId),
    shallow,
  );

  //shareUser
  const sharingUserId =
    post?.content.type == PostContentType.User
      ? post.content.userId
      : NOT_APPLICABLE_STRING;
  const sharingUser = useUserStore.getState().getProfile(sharingUserId);

  const sharingClassroomId =
    post?.content.type == PostContentType.Space
      ? post.content.classroomId
      : NOT_APPLICABLE_STRING;

  const sharingSpace = useSpaceStore((store) => {
    return store.getSpace(sharingClassroomId);
  }, shallow);

  const sharingSpaceOwner = useUserStore((store) => {
    const profile = store.getProfileFromMap(
      ProfileMapType.SpaceRoot,
      sharingClassroomId,
    );
    return profile;
  }, shallow);

  return (
    <>
      {status == 'loading' ? (
        <div
          className="flex flex-col justify-center items-center"
          style={{ flex: 1 }}
        >
          <Spinner
            animation="border"
            role="status"
            style={{ color: '#05656B' }}
          >
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      ) : (
        <PostTemplate
          post={post}
          creator={creatorUserProfile}
          classroom={classroom}
          albumClassroom={albumClassroom}
          album={album}
          membership={membership}
          //
          sharingSpace={sharingSpace}
          sharingSpaceOwner={sharingSpaceOwner}
          //
          sharingUser={sharingUser}
          postFailedFetch={status == 'error'}
        />
      )}
    </>
  );
};
